import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/providers/Store';

const selectEngineMeasurementState = (state: RootState) => state.engineMeasurement;

const selectAllEngineMeasurements = createSelector(
  [selectEngineMeasurementState],
  (engineMeasurementState) => engineMeasurementState.engineMeasurements,
);

const selectEngineMeasurementLoading = createSelector(
  [selectEngineMeasurementState],
  (engineMeasurementState) => engineMeasurementState.isLoading,
);

const selectEngineMeasurementDetail = createSelector(
  [selectEngineMeasurementState],
  (engineMeasurementState) => engineMeasurementState.engineMeasurementDetail.data,
);

const selectEngineMeasurementDetailLoading = createSelector(
  [selectEngineMeasurementState],
  (engineMeasurementState) => engineMeasurementState.engineMeasurementDetail.isLoading,
);

const selectEngineMeasurementById = createSelector(
  [selectAllEngineMeasurements, (_: RootState, id: number) => id],
  (engineMeasurements, id) => engineMeasurements.find((item) => item.id === id),
);

export const engineMeasurementSelectors = {
  getAllEngineMeasurements: selectAllEngineMeasurements,
  getLoading: selectEngineMeasurementLoading,
  getDetail: selectEngineMeasurementDetail,
  getDetailLoading: selectEngineMeasurementDetailLoading,
  getById: selectEngineMeasurementById,
};
